import React, {useEffect, useState} from "react";
import styles from "./lazyImage.module.scss";

export interface ILinkBlockElementProps {
  src: string | string[],
  title?: string;
  alt?: string;
  onError?: (event: any) => void;
  style?: any;
  className?: string;
  elementOnError?: any;
}


const LazyImage = (props: ILinkBlockElementProps) => {
  const src = Array.isArray(props.src) ? props.src[0] : props.src;
  const [imgSrc, setImgSrc] = useState<string | undefined>(src)
  const onError = () => {
    if (Array.isArray(props.src)) {
      const currentSrcIndex = props.src.indexOf(imgSrc);
      if (props.src[currentSrcIndex + 1]) {
        setImgSrc(props.src[currentSrcIndex + 1]);
      } else {
        setImgSrc(null);
      }
    }
  }
  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  if (imgSrc === null) {
    return (props.elementOnError);
  } else {
    return (
      <img
        key={src}
        className={`${styles.lazyImg} ${props.className}`.trim()}
        src={imgSrc}
        referrerPolicy="no-referrer"
        alt={props.alt || props.title}
        title={props.title || props.alt}
        onError={(event) => {
          onError();
          if (typeof props.onError === 'function') {
            props.onError(event);
          }
        }}
        style={props.style}
        loading="lazy"
      />
    );
  }
};

LazyImage.defaultProps = {
  title: '',
  alt: '',
  className: '',
  elementOnError: null,
  onError: (e) => {
  }
};

export default React.memo(LazyImage);
